// Denominations the EU VAT path rates in. Mirrors `WIRE_CURRENCY` in
// svc/listing's `eu-tax-candidates.ts`: EUR for EU member states and GBP
// for GB→GB domestic supplies (FP-3109). DKK/SEK/PLN/CZK etc. resolve no
// rate and come back as `estimateUnavailable: true`, so gating them out
// here keeps the network round-trip off the ineligible listings entirely.
// Taxability itself follows the addresses — svc/listing yields no candidate
// for a GBP listing shipping GB→EU.
const EU_TAX_CURRENCIES = new Set(['EUR', 'GBP'])

const isEuTaxCurrency = (currency?: string): boolean =>
  !!currency && EU_TAX_CURRENCIES.has(currency.toUpperCase())

export default isEuTaxCurrency
